// @flow
import React from 'react';
import { TextField } from '@mui/material';

type FormFieldTextProps = {|
  field: Object,
  onChange: Function,
  value: string,
  error: any,
  styles?: Object,
  endAdornment?: Node,
  testId?: string,
|};

const FormFieldText = ({
  field,
  onChange,
  value,
  error,
  styles = {},
  endAdornment = null,
  testId = 'text-field',
  ...otherProps
}: FormFieldTextProps): React$Element<any> => {
  const {
    InputProps,
    multiline,
    validator,
    errorMessage,
    key,
    ...otherFieldProps
  } = field;
  const inputProps = {
    inputProps: { 'data-testid': testId },
    InputProps: {
      ...InputProps,
      sx: styles && styles.textFieldInput,
      endAdornment,
    },
  };

  return (
    <TextField
      {...otherFieldProps}
      {...otherProps}
      {...inputProps}
      value={value}
      onChange={onChange}
      error={error && Boolean(error)}
      helperText={error ? error.message : null}
      sx={
        multiline
          ? styles && styles.textFormFieldMultiLine
          : styles && styles.textFormField
      }
      variant="standard"
    />
  );
};

export default FormFieldText;
